import type { FC, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiGallection } from '@wix/da-papi-types';
import StandardMenu from '@wix/da-ds/pkg/Dropdown/MenuPreset/StandardMenu';

import s from './MoveToFolderMenu.scss';

export interface Props {
  selectedFolder: PapiGallection;
  subfolders?: PapiGallection[];
  featuredFolderId?: number;
  isRootStashFolder?: boolean;
  hasMoreSubfolders?: boolean;
  onMoveToFolder: (targetFolderId: number, action?: string) => void;
  fetchMoreSubfolders: () => void;
}

const MoveToFolderMenu: FC<Props> = ({
  selectedFolder,
  subfolders,
  featuredFolderId,
  isRootStashFolder,
  hasMoreSubfolders,
  onMoveToFolder,
  fetchMoreSubfolders,
}) => {
  const { t } = useTranslation();
  const parentFolderId = selectedFolder?.parentId || featuredFolderId;
  return (
    (<StandardMenu
      id="move-to-folder-menu"
      menuClassName={s['folders-menu']}
      items={[
        {
          items: [
            {
              label: t('studio.table.actions.folders.up'),
              onClick: isRootStashFolder
                ? undefined
                : () => onMoveToFolder(parentFolderId!, 'move_up'),
              disabled: isRootStashFolder,
            },
          ],
        },

        subfolders && subfolders.length > 0
          ? {
              items: subfolders.map(folder => ({
                label: folder.name,
                // using `complexLabel` to avoid the default wrapper on `label`
                complexLabel: folder.name,
                onClick: () => onMoveToFolder(folder.folderId, 'move_down'),
              })),
            }
          : null,

        hasMoreSubfolders
          ? {
              items: [
                {
                  label: t('studio.folderList.loadMore'),
                  onClick: (ev: MouseEvent) => {
                    // stop propagation to avoid submenu getting closed
                    ev.stopPropagation();
                    fetchMoreSubfolders();
                  },
                },
              ],
            }
          : null,
      ]}
    />)
  );
};
MoveToFolderMenu.displayName = 'MoveToFolderMenu';

export default MoveToFolderMenu;
